export class InfoMessage {
  constructor(
    public message: string,
    public isError = false,
    public url: string | null = null,
    public title: string | null = null
  ) {}
}
